import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { jwordBorderThicknessOptions,jwordBorderAppRangeOptions,colorList} from "./jword-config";
import { ListBox } from "primereact/listbox";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";

export function FibDialog({fibProps,visible,onOK,onCancel})
{    
    const {t} = useTranslation();    
    const fibTypes=['TEXT','LIST','CORRECTION'];
    const [fibInfo,setFibInfo]=useState(fibProps);
    const [answers,setAnswers]=useState(fibProps.answers);
    const [answer,setAnswer]=useState('');
    const [correctOptionDisabled,setCorrectOptionDisabled]=useState(true);
    
    const onChange=(formData)=>{     
        var cod = (formData.fibType != 'LIST'); 
        setCorrectOptionDisabled(cod);
        setFibInfo(formData);        
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        fibInfo.answers=answers;
        onOK(fibInfo);
    };
    const addAnswer=()=>{
        if(answer.trim().length == 0)
            return;
        var ans = [...answers];
        ans.push(answer);
        setAnswer('');
        setAnswers(ans);
    };
    const onOptionChange=(e)=>{
        setAnswer(e.target.value);
    };
    const onOptionDelete=(data)=>{
		var anss = answers.filter(a =>a != data);
		setAnswers(anss);
    };
    const onOptionKey=(e)=>{
		if(e.keyCode == 13)
			addAnswer(e);
    };
	const optionsItemTemplate=(data)=>{
		return( 	
        <div className="flex gap-1 p-0">
		    <div className="col-11 p-0">{data}</div>	
		    <div className="col-1 align-end p-0"><i className="pi pi-times p-button p-button-sm p-button-rounded p-button-danger p-button-text" onClick={(e)=>onOptionDelete(data)}/></div>
		</div>
        );
	};
    useEffect(()=>{
        console.log("fibProps:"+JSON.stringify(fibProps));
        setFibInfo(fibProps);
        setAnswers(fibProps.answers);
        setCorrectOptionDisabled(fibProps.fibType != 'LIST');
    },[fibProps]);

    return(
        <>
        <CommonDialog header={t('Editor.Blanks_filling_field')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form id="fib" formData={fibInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"fibType",ftype:"dropdown",field:"fibType",label:t('Editor.fib.Type'),options:fibTypes},
                    {id:"length",ftype:"number",field:"length",label:t('Editor.fib.Length')},                    
                    {id:"caseSensitive",ftype:"checkbox",field:"caseSensitive",label:t('Editor.fib.Case_sensitive')},
                    {id:"correctOption",ftype:correctOptionDisabled?'none':'number',field:"correctOption",label:t('Editor.fib.Correct_option')}
                ]}>
            </Form>            	
            <Panel header={fibInfo.fibType == 'LIST'?t('Editor.fib.Options'):t('Editor.fib.Values_accepted_as_correct')}>
                <div className="p-inputgroup" id="options">
                    <InputText id="addOption" type="text" onKeyUp={onOptionKey} onChange={onOptionChange} value={answer} placeholder={t('Editor.fib.answer')} />
                    <Button icon="pi pi-plus" className="p-button-secondary" onClick={addAnswer}/>
                </div>
                <ListBox emptyMessage=" " options={answers} style={{height:'150px'}} itemTemplate={optionsItemTemplate} listStyle={{ maxHeight: '150px' }}></ListBox>
            </Panel>
            </div>
        </CommonDialog>
        </>
    );
}